import React from 'react';
import { ArrowRight } from 'lucide-react';

const CategoryCard = ({ item }) => {
  return (
    <div className="relative p-4 rounded-lg text-center text-white cursor-pointer w-[300px] h-[300px] overflow-hidden group">
      {/* Image wrapper */}
      <div className="w-full h-[250px] overflow-hidden rounded-md">
        <img
          src={item.image}
          alt={item.name}
          className="w-full h-full object-cover transform transition-transform duration-500 group-hover:scale-110"
        />
      </div>

      {/* Text content */}
      <div className="absolute bottom-[23%] left-7 text-left">
        <h2 className="text-2xl font-semibold">{item.name}</h2>
        <p>{item.description}</p>
      </div>

      {/* Button with hover effect */}
      <button
        className="absolute bottom-10 left-20 transform -translate-x-1/2 mt-3 text-white px-4 py-2 rounded-3xl flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
      >
        Shop Now <ArrowRight size={18} />
      </button>
    </div>
  );
};

export default CategoryCard;
